import React, { forwardRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useFlags } from 'launchdarkly-react-client-sdk';
import {
  talis,
  panopto,
  planetEStream,
  assignment,
  echo360,
  h5p,
  bibliu,
  templates,
  genericLti,
} from '@ublend-npm/aula-editor';
import {
  isTalisEnabled as getIsTalisEnabled,
  isEchoEnabled as getIsEchoEnabled,
  isPlanetEnabled as getIsPlanetEnabled,
  isPanoptoEnabled as getIsPanoptoEnabled,
  isBibliuEnabled as getIsBibliuEnabled,
  isH5PEnabled as getIsH5PEnabled,
} from '../../../../../core/selectors/lti';

const withPlugins = (AulaEditor) => {
  const AulaEditorWithPlugins = forwardRef(
    (
      {
        plugins,
        isTalisEnabled,
        isPanoptoEnabled,
        isPlanetEnabled,
        isEchoEnabled,
        isAssignmentsEnabled,
        isH5PEnabled,
        isBibliuEnabled,
        ...props
      },
      ref
    ) => {
      const {
        webappFtEditorTemplatesEnabled202110: isTemplatesEnabled,
        ftSelfServeLtiEnabled202204: isGenericLtiEnabled,
      } = useFlags();

      const editorPlugins = useMemo(() => {
        const mergedPlugins = [...plugins];

        if (isPanoptoEnabled) mergedPlugins.push(panopto);
        if (isPlanetEnabled) mergedPlugins.push(planetEStream);
        if (isEchoEnabled) mergedPlugins.push(echo360);
        if (isTalisEnabled) mergedPlugins.push(talis);
        if (isAssignmentsEnabled) mergedPlugins.push(assignment);
        if (isH5PEnabled) mergedPlugins.push(h5p);
        if (isBibliuEnabled) mergedPlugins.push(bibliu);
        if (isGenericLtiEnabled) mergedPlugins.push(genericLti);
        if (isTemplatesEnabled) mergedPlugins.push(templates);

        return mergedPlugins;
      }, [
        plugins,
        isPanoptoEnabled,
        isPlanetEnabled,
        isEchoEnabled,
        isTalisEnabled,
        isAssignmentsEnabled,
        isH5PEnabled,
        isBibliuEnabled,
        isGenericLtiEnabled,
        isTemplatesEnabled,
      ]);

      return <AulaEditor ref={ref} plugins={editorPlugins} {...props} />;
    }
  );

  AulaEditorWithPlugins.displayName = 'AulaEditorWithPlugins';

  AulaEditorWithPlugins.propTypes = {
    plugins: PropTypes.arrayOf(PropTypes.object),
    isTalisEnabled: PropTypes.bool,
    isPanoptoEnabled: PropTypes.bool,
    isPlanetEnabled: PropTypes.bool,
    isEchoEnabled: PropTypes.bool,
    isAssignmentsEnabled: PropTypes.bool,
    isH5PEnabled: PropTypes.bool,
    isBibliuEnabled: PropTypes.bool,
    config: PropTypes.object,
  };

  AulaEditorWithPlugins.defaultProps = {
    isTalisEnabled: false,
    isPanoptoEnabled: false,
    isPlanetEnabled: false,
    plugins: [],
    isEchoEnabled: false,
    isAssignmentsEnabled: false,
    isH5PEnabled: false,
    isBibliuEnabled: false,
    config: {},
  };

  const mapStateToProps = (state) => ({
    isTalisEnabled: getIsTalisEnabled(state),
    isEchoEnabled: getIsEchoEnabled(state),
    isPlanetEnabled: getIsPlanetEnabled(state),
    isPanoptoEnabled: getIsPanoptoEnabled(state),
    isBibliuEnabled: getIsBibliuEnabled(state),
    isH5PEnabled: getIsH5PEnabled(state),
  });

  return connect(mapStateToProps, null, null, { forwardRef: true })(
    AulaEditorWithPlugins
  );
};

export default withPlugins;
